import BaseToast, {ToastProps} from "@FRAMEWORK/ui/common/Toast";

const Toast = (props: Omit<ToastProps, "nowrap">) => <BaseToast {...props} nowrap />;

export default Toast;
